"use strict";
exports.__esModule = true;
var earth_1 = require("./earth");
var crs_epsg3857_1 = require("./crs-epsg3857");
var crs_epsg4326_1 = require("./crs-epsg4326");
var crs_simple_1 = require("./crs-simple");
// 所有的 Coord map
var CRS_MAP = {
    // crs:CRS,
    epsg3857: crs_epsg3857_1.epsg3857,
    epsg4326: crs_epsg4326_1.epsg4326,
    simple: crs_simple_1.simple,
    earth: earth_1.earth,
    epsg900913: crs_epsg3857_1.epsg900913
};
/**
 * 通过类型获得 Coord 类
 * @param type
 */
exports.getCRS = function (type) {
    return CRS_MAP[type.toLowerCase()];
};
//# sourceMappingURL=index.js.map